import React from "react";

function Icon() {
  return (
    <svg height="15" width="14" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.67"
        d="M12.833 7.5H1.167m0 0L7 13.333M1.167 7.5L7 1.667"
      ></path>
    </svg>
  );
}

export default Icon;
